import {NgModule} from '@angular/core'
import {CommonModule} from '@angular/common'
import {FontAwesomeModule} from '@fortawesome/angular-fontawesome'
import {SidenavComponent} from './sidenav.component'
import {SidenavItemComponent} from './sidenav-item/sidenav-item.component'
import {SidenavItemsComponent} from './sidenav-items/sidenav-items.component'
import {RouterModule} from '@angular/router'
import {ChipComponent} from '../chip/chip.component'
import {DynamicIconModule} from '../dynamic-icon/dynamic-icon.module'

@NgModule({
  declarations: [SidenavComponent, SidenavItemsComponent, SidenavItemComponent],
  exports: [SidenavComponent, SidenavItemComponent, SidenavItemsComponent],
  imports: [CommonModule, FontAwesomeModule, RouterModule, ChipComponent, DynamicIconModule],
})
export class SidenavModule {}
